import {
  useGetCandidatesByCandidateProfileQuery,
  useGetOtherConversationsByCandidateProfileQuery,
  useGetSourcedCandidatesByCandidateProfileQuery,
  useGetAttachmentsByCandidateProfileQuery
} from 'generated-graphql/hooks/apollo-hooks';
import { useEffect } from 'react';
import { useCandidateProfileStore } from 'modules/candidate-profile/stores/useCandidateProfileStore';
import { extractQueryListItems } from 'core/utils/apollo/extractListItems';

type UseGetCandidateProfileDetailsTabsDataProps = {
  candidateProfileId: string;
};

export const useGetCandidateProfileDetailsTabsData = ({
  candidateProfileId
}: UseGetCandidateProfileDetailsTabsDataProps) => {
  const setSourcedCandidates = useCandidateProfileStore(
    (state) => state.setSourcedCandidates
  );
  const setAnalysedApplications = useCandidateProfileStore(
    (state) => state.setAnalysedApplications
  );
  const setConversations = useCandidateProfileStore(
    (state) => state.setConversations
  );
  const setAttachments = useCandidateProfileStore(
    (state) => state.setAttachments
  );

  const { data: sourcedCandidates } =
    useGetSourcedCandidatesByCandidateProfileQuery({
      variables: {
        candidateProfileId
      }
    });
  const { data: candidates } = useGetCandidatesByCandidateProfileQuery({
    variables: {
      candidateProfileId
    }
  });
  const { data: conversations } =
    useGetOtherConversationsByCandidateProfileQuery({
      variables: {
        candidateProfileId
      }
    });
  const { data: attachments } = useGetAttachmentsByCandidateProfileQuery({
    variables: {
      candidateProfileId
    }
  });

  useEffect(() => {
    const sourcedCandidatesItems = extractQueryListItems(sourcedCandidates);
    setSourcedCandidates(sourcedCandidatesItems);
  }, [sourcedCandidates]);

  useEffect(() => {
    const candidatesItems = extractQueryListItems(candidates);
    setAnalysedApplications(candidatesItems);
  }, [candidates]);

  useEffect(() => {
    const conversationsItems = extractQueryListItems(conversations);
    setConversations(conversationsItems);
  }, [conversations]);

  useEffect(() => {
    const attachmentsItems = extractQueryListItems(attachments);
    setAttachments(attachmentsItems);
  }, [attachments]);

  // NOTE: Don't return anything here, as the data is passed to the store.
  // This is to avoid re-fetching the data when the component is rendered.
  return {};
};
